var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart",class:{ 'chart--social-mode': _vm.socialMode, 'chart--no-footer': _vm.noFooter, 'chart--active-route-view': _vm.isActiveRouteView }},[_c(_vm.chart,{tag:"component",attrs:{"socialMode":_vm.socialMode}}),(_vm.showFooter)?_c('embeddable-footer',{staticClass:"position-absolute"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }